import { ServiceConfig } from '../models/referential/service-config.model';
import {Observable} from "rxjs";
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Page} from "../utils/page";
import {ServiceConfigByCountryAndRole} from "../models/referential/service-config-by-country-and-role.model";
import {SynthesisViewConfig} from "../models/synthesis/synthesis-view-config.model";
import {EmployeeRoleEnum} from "../models/employee/employee-role.enum";
import {Country} from "../models/referential/country.model";
import { NumberOfChangeStock } from '../models/number-of-change-stock/number-of-change-stock';
import { Option } from '../models/option/option.model';

export abstract class ReferentialService {

    API_URL = '/apiParams/v1';

    constructor(protected readonly http: HttpClient) {}

    generateReferentialServices(serviceConfigs: ServiceConfig[], options: Option[]): any[] {

        let referentialServices: any[] = [];
        serviceConfigs.forEach(item => {
            let jsonParameter = {};
            jsonParameter["serviceCode"] = item.serviceCode;
            item.parameters.forEach(param => {
                jsonParameter[param.key] = param.value;
            });
            // push VT options to the referential services
            jsonParameter["options"] = options
                ? options
                    .filter(option => option.serviceCode === item.serviceCode)
                : [];

            referentialServices.push(jsonParameter)
        });
        return referentialServices;
    }

    getSortedSynthesisViewConfig(synthesisViewConfig: SynthesisViewConfig[]) {
        const order = ['contract', 'full', 'intermediate', 'simple'];
        return synthesisViewConfig
            .filter(view => view.enabled)
            .sort((a, b) => {
                if (a.isDefault && !b.isDefault) return -1;
                if (!a.isDefault && b.isDefault) return 1;
                return order.indexOf(a.name) - order.indexOf(b.name);
            });
    }

    getTranslations(locale: string, ifNoneMatch?: string): Observable<HttpResponse<any>> {
        const params = new HttpParams()
            .set('application', 'epp-client')
            .set('locale', locale);
        const headers: { [key: string]: string } = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = `"${ifNoneMatch}"`;
        }
        return this.http.get<any>(this.API_URL + '/translations', { params, headers, observe: 'response' });
    }

    abstract getAllServices(filters: Map<string, string>): Observable<Page<ServiceConfigByCountryAndRole>>;

    abstract getSynthesisViewConfig(roleCode: string, countryIsoCode: string): Observable<SynthesisViewConfig[]>;

    abstract getReferential(country: string, role: EmployeeRoleEnum) : Observable<any>;

    abstract getEnabledServiceConfigs(roleCode: EmployeeRoleEnum, countryIsoCode: string) : Observable<ServiceConfig[]>;

    abstract getCountry(countryIsoCode: string) : Observable<Country>;

    abstract getAutomaticArticles(countryCode: string, roleCode: string, serviceCode: string): Observable<any>;

    abstract getNumberOfChangeStock(): Observable<Page<NumberOfChangeStock>>;

    abstract getOptions(countryIsoCode: string, roleCode: string): Observable<Page<Option>>;

    abstract getWashRateNLifetime(countryIsoCode: string, roleCode: string, serviceCode: string, subMarket: string, epi: string, family: string): Observable<any>;

    abstract getGrossMarginRate(countryIsoCode: string, roleCode: string, serviceCode: string, subMarket: string, family: string, subFamily: string): Observable<any>;


}
